export const HERO_IMG =
  "https://images.unsplash.com/photo-1696332221524-5916ceecfff5?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

export const designServices = [
  {
    n: "01",
    title: "Concept / Styling",
    desc: "Shape product form, proportion and detail — the visual language that gives an object its identity.",
    img: "/concept-styling.png",
  },
  {
    n: "02",
    title: "Design in Virtual Reality",
    desc: "Rapid 3D conceptualisation using immersive VR tools — sketch in real scale, in real time.",
    img: "/design-in-vr.jpg",
  },
  {
    n: "03",
    title: "Surfacing",
    desc: "Refine 3D geometry for smooth, high-quality Class-A surfaces for manufacture.",
    img: "/surfacing.webp",
  },
  {
    n: "04",
    title: "CAD Design",
    desc: "Build digital models for prototype validation and manufacture — designed to tolerance.",
    img: "/cad-design-v2.png",
  },
  {
    n: "05",
    title: "Compliance",
    desc: "Engineer checked and approved to ensure full quality and safety.",
    img: "/compliance.png",
  },
  {
    n: "06",
    title: "Work",
    desc: "Have a look at some of the projects we've worked on.",
    img: "/see-our-work.jpg",
    link: "/work",
  },
];

export const fabricationServices = [
  {
    n: "01",
    title: "Clay Modelling",
    desc: "Sculpt physical models to explore form and ergonomics — the hand still wins.",
    img: "/clay-modelling.png",
  },
  {
    n: "02",
    title: "Panel Surfacing",
    desc: "Develop precise outer skin geometry for body panels — every reflection considered.",
    img: "/panel-surfacing.jpg",
  },
  {
    n: "03",
    title: "Large Format 3D Printing",
    desc: "Create mock-ups and working prototypes to test form, fit and function.",
    img: "/large-format-3d-printing.jpg",
  },
];

export const workProjects = [
  {
    n: "01",
    title: "1950's F1 Inspired Race Car",
    quote:
      "Cerra Design delivered an outstanding combination of styling, engineering, and professionalism. Their buck design process made fabrication straightforward, improved accuracy, and saved valuable build time. The attention to detail and practical understanding of coachbuilding resulted in a finished buck that exceeded our expectations. We highly recommend Cerra Design for anyone seeking innovative automotive design backed by real-world manufacturing expertise.",
    author: "Peter Lamb, Melomotive",
    img: "/f1-race-car.jpg",
  },
  {
    n: "02",
    title: "Diesel Drivetrain Scale Model",
    quote:
      "Cerra Design produced a highly detailed, realistic scale model of our diesel drivetrain that became a standout feature at trade shows and in our client's foyer. The quality, accuracy, attention to detail and presentation exceeded our expectations. Their professionalism, attention to detail, and reliable delivery made the entire process effortless.",
    author: "James Buffington, Aurora Design",
    img: "/diesel-drivetrain-testimonial.webp",
  },
  {
    n: "03",
    title: "Tank Gauge Mount",
    quote:
      "Cerra Design's tank gauge mount adds a beautifully considered touch. The industrial aesthetic blends seamlessly with the existing lines, giving the build a more intentional and refined look. It feels purpose-designed rather than aftermarket, adding a subtle uniqueness that really elevates the bike's character. A premium piece that fits with absolute confidence.",
    author: "Adam D., Action Motorcycles",
    img: "/tank-gauge-mount.jpg",
  },
];

export const workPageItems = [
  {
    n: "01",
    title: "1950's F1 Inspired Race Car",
    desc: "Styling and coachbuilding buck development in collaboration with Melomotive.",
    video: "/f1-race-car.mp4",
  },
  {
    n: "02",
    title: "Diesel Drivetrain Scale Model",
    desc: "Faithful scale replica of the famous Cummins drivetrain, developed in collaboration with Aurora Design.",
    video: "/diesel-drivetrain.mp4",
  },
  {
    n: "03",
    title: "Reimagining the Flying Brick",
    desc: "Can the K100 be a muscle bike streetfighter? In short, yes. Leant heavily on VR for concept and design, and 3D printing for fabrication.",
    img: "/flying-brick.jpg",
  },
  {
    n: "04",
    title: "See some of Skunk Machine's previous builds",
    desc: "Motorcycle builds & parts, forged from moto-culture.",
    link: "https://www.skunkmachine.com/our-work-1",
    cta: true,
    img: "/skunk-previous-builds.png",
  },
];

export const SKUNK_IMG =
  "https://images.pexels.com/photos/2805547/pexels-photo-2805547.jpeg?auto=compress&cs=tinysrgb&w=2000";
export const SKUNK_URL = "https://www.skunkmachine.com/";
export const EMAIL = "STUDIO@CERRADESIGN.COM";
